import { useEffect } from 'react';
import { IntlProvider } from 'react-intl';
import { connect } from 'react-redux';

import { isEnabled } from 'Config';

import { getContextLanguage } from 'Store/context/selectors';
import { DEFAULT_LANGUAGE } from 'Store/internationalization/constants';
import { getIsLanguageLoaded } from 'Store/internationalization/selectors';
import getLocaleObject from 'Store/internationalization/utils/getLocaleObject';

import LoadingScreen from 'Components/LoadingScreen';

type Props = React.PropsWithChildren<{
  intlMessages?: Record<string, string>;
  lang?: string;
  loaded?: boolean;
}>;

export const LOADING_SCREEN_TESTID = 'language-switch-loading-screen';

export const UnconnectedLanguageProvider = (props: Props) => {
  const { children, intlMessages, lang = DEFAULT_LANGUAGE, loaded } = props;

  useEffect(() => {
    if (lang) {
      const { fullLocale } = getLocaleObject(lang);
      document.documentElement.lang = fullLocale;
    }
  }, [lang]);

  if (__CLIENT__ && !loaded) {
    return isEnabled('skipLoadingScreen') ? null : (
      <LoadingScreen data-testid={LOADING_SCREEN_TESTID} />
    );
  }

  return (
    <IntlProvider locale={lang} messages={intlMessages}>
      {children}
    </IntlProvider>
  );
};

function mapStateToProps(state) {
  const { intlMessages } = state;

  return {
    intlMessages,
    lang: getContextLanguage(state),
    loaded: getIsLanguageLoaded(state),
  };
}

export default connect(mapStateToProps)(UnconnectedLanguageProvider);
